let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k8R1k")).then(() => parcelRequire('hYUU3'));